import {ChecklistQuestion} from './checklist-question';
import {MultipleChoiceQuestion} from './multiple-choice-question';
import { Question } from "app/shared/models/question";
import { QuestionSet } from "app/shared/models/question-set";
import { QuestionType } from "app/shared/models/question-type";
import { QuestionSetLabel } from "app/shared/models/question-set-label";

export class FlaggedCondition {

    private _flagDirection:string;
    private _flagValues:QuestionSetLabel[];

    constructor() {
        this.flagDirection = null;
        this.clearFlagValues();
    }

    public clearFlagValues() {
        this._flagValues = [];
    }

    public addFlagValue(lbl:QuestionSetLabel) {
        let index = this._flagValues.findIndex(fl => fl.id == lbl.id);
        if (index !== -1) {
            this._flagValues[index] = lbl;
        }
        this._flagValues.push(lbl);
    }
    public removeFlagValue(lbl:QuestionSetLabel) {
        this._flagValues = this._flagValues.filter(fl => fl.id != lbl.id);
    }

    public get flagValues() {
        return this._flagValues;
    }

    public set flagDirection(v:string) {
        this._flagDirection = v;
    }
    public get flagDirection() {
        return this._flagDirection;
    }

    public shouldFlagQuestion(question:Question, questionSet:QuestionSet) {
        
        if (!question.hasAnswer) {
            return false;
        }

        if (question.type == QuestionType.Textbox
            || question.type == QuestionType.SingleChoice) {
            return true;
        }
        let lbls = questionSet.labels;
        if (question.type == QuestionType.MultipleChoice) {
            let mcQuestion = question as MultipleChoiceQuestion;
            // there is only one with multiple choice questions
            let flagValue = this._flagValues[0];
            let index = lbls.findIndex(l => l.id == flagValue.id);
            let answerIndex = lbls.findIndex(l => l.id == mcQuestion.answer.id);
            if (this.flagDirection == 'greaterOrEqual') {
                return answerIndex >= index;
            }
            else {
                return answerIndex <= index;
            }
        }
        if (question.type == QuestionType.Checklist) {
            let clQuestion = question as ChecklistQuestion;
            let answers = clQuestion.answerForSave;
            let flagAnswer = lbls.some(l => answers[l.id]);
            return flagAnswer;
        }
        return false;
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/models/flagged-condition.ts